import { FunctionComponent } from 'react'
import { BusyIndicator } from '@medable/medable-web-ui'

export const Loading: FunctionComponent = () => (
  <div className='flex flex-col items-center'>
    <BusyIndicator />
  </div>
)
